<template>
    <div class="container">
        <div class="header" v-if="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.product_name" placeholder="请输入课程名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.video_name" placeholder="请输入视频名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="productName" label="课程名称"></el-table-column>
            <el-table-column prop="videoName" label="视频名称"></el-table-column>
            <el-table-column prop="videoSort" label="序号"></el-table-column>
            <el-table-column prop="videoImage" label="图片">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="img" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.videoImages)" :initial-index="index"
                        v-for="(img, index) in getThumbImageSrcList(scope.row.videoImages)"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.videoDate) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="videoPlay(scope.row.videoSrc)" type="text" size="small" v-if="scope.row.videoSrc">视频</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="选择课程" v-if="!productId">
                        <el-select v-model="handleInfo.productId" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in products" :key="item.productId" :label="item.productName" :value="item.productId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="视频名称">
                        <el-input v-model="handleInfo.videoName"></el-input>
                    </el-form-item>
                    <el-form-item label="视频序号">
                        <el-input v-model="handleInfo.videoSort"></el-input>
                    </el-form-item>
                    <el-form-item label="视频信息">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('videoSrc')">
                                <video class="upload-image" :src="getThumbImageSrc(img)" controls></video>
                                <div @click="uploadRemove('videoSrc', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'videoSrc' }" accept=".mp4, .avi, .wmv, .mov, .mkv"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="视频图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('videoImages')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('videoImages', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'videoImages' }" accept=".jpg,.jpeg,.bmp,.png"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="视频简述">
                        <el-input type="textarea" v-model="handleInfo.videoDesc" :rows="3"></el-input>
                    </el-form-item>
                    <el-form-item label="视频内容">
                        <el-input type="textarea" v-model="handleInfo.videoContent" :rows="8"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="视频播放" :visible.sync="isVideo" width="70%" :close-on-click-modal="false" @close="videoClose()">
            <video :src="videoSrc" controls style="width: 100%;" ref="videoPlayer"></video>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    props: {
        header: {
            type: Boolean,
            default: true
        },
        productId: {
            type: String,
            default: ""
        }
    },
    data: function () {
        return {
            products: [],
            isVideo: false,
            videoSrc: ""
        }
    },
    watch: {
        productId: function(newVal) {
            this.filterParams.product_id = newVal;
            this.initialData();
        }
    },
    methods: {
        videoPlay: function(src) {
            this.videoSrc = this.getImageSrc(src);
            this.isVideo = true;
        },
        videoClose: function() {
            this.$refs.videoPlayer.pause();
            this.isVideo = false;
        },
        beforeHandleOpenEx: function(handle) {
            if (this.handle == "insert" && this.productId) {
                this.handleInfo.productId = this.productId;
            }
        }
    },
    created: async function () {
        console.log("VideoListView created");
        this.tag = "VIDEO";
        this.uploads.push({
            column: "videoImages",
            files: []
        });
        this.uploads.push({
            column: "videoSrc",
            files: []
        });
        if (this.productId) {
            this.filterParams.product_id = this.productId;
        }
        this.products = await doGet(API.ALL.PRODUCT);
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>